/* Floty · homepage v2 (protótipo): menus (clique, teclado, passar o rato no computador), gaveta no celular e a mini-raia das Ferramentas. */
(function () {
  'use strict';
  var botoes = [].slice.call(document.querySelectorAll('.menu > li > button[aria-controls]'));
  var largo = window.matchMedia('(min-width: 1241px)');
  var fechaTimer = null;

  function painel(b) { return document.getElementById(b.getAttribute('aria-controls')); }
  function fecha(b) { b.setAttribute('aria-expanded', 'false'); painel(b).hidden = true; }
  function abre(b) { botoes.forEach(function (o) { if (o !== b) fecha(o); }); b.setAttribute('aria-expanded', 'true'); painel(b).hidden = false; }
  function fechaTodos() { botoes.forEach(fecha); }

  botoes.forEach(function (b) {
    var abertoPeloRato = 0;  // quem passa o rato e clica logo a seguir quer o menu aberto, não fechado
    b.addEventListener('click', function () {
      if (b.getAttribute('aria-expanded') === 'true' && Date.now() - abertoPeloRato > 600) fecha(b); else abre(b);
    });
    var li = b.parentElement;
    li.addEventListener('mouseenter', function () {
      if (!largo.matches) return; clearTimeout(fechaTimer);
      if (b.getAttribute('aria-expanded') !== 'true') abertoPeloRato = Date.now();
      abre(b);
    });
    li.addEventListener('mouseleave', function () { if (!largo.matches) return; fechaTimer = setTimeout(function () { fecha(b); }, 180); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var aberto = botoes.filter(function (b) { return b.getAttribute('aria-expanded') === 'true'; })[0];
    fechaTodos(); fechaGaveta();
    if (aberto) aberto.focus();
  });
  document.addEventListener('click', function (e) { if (largo.matches && !e.target.closest('.menu')) fechaTodos(); });
  // miniaturas dos menus: começam a carregar quando o rato (ou o teclado) chega à barra, não só quando o painel abre
  var menu = document.querySelector('.menu');
  function preCarrega() { [].forEach.call(menu.querySelectorAll('img[loading="lazy"]'), function (i) { i.loading = 'eager'; }); }
  if (menu) { menu.addEventListener('mouseenter', preCarrega, { once: true }); menu.addEventListener('focusin', preCarrega, { once: true }); }

  // gaveta do celular
  var nav = document.getElementById('menu-principal'), abrir = document.querySelector('[data-abrir-menu]');
  function fechaGaveta() { nav.classList.remove('aberto'); if (abrir) abrir.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
  if (abrir) abrir.addEventListener('click', function () { nav.classList.add('aberto'); abrir.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; nav.querySelector('button, a').focus(); });
  var fechar = document.querySelector('[data-fechar-menu]');
  if (fechar) fechar.addEventListener('click', function () { fechaGaveta(); abrir.focus(); });
  largo.addEventListener('change', function () { fechaGaveta(); fechaTodos(); });

  // mini-raia: pontas vermelhas (5 m em cada lado) e o meio alternando a cor escolhida com o branco
  var g = document.getElementById('discos');
  function desenhaRaia(cor) {
    if (!g) return;
    var n = 26, x0 = 20, passo = (620 - x0) / (n - 1), html = '<line x1="6" y1="35" x2="634" y2="35" stroke="#5F6B73" stroke-width="2"/>';
    for (var i = 0; i < n; i++) {
      var ponta = i < 4 || i >= n - 4, c = ponta ? '#D7322B' : (i % 2 ? '#F6F8F9' : cor);
      html += '<ellipse cx="' + (x0 + i * passo).toFixed(1) + '" cy="35" rx="10.5" ry="24" fill="' + c + '" stroke="rgba(7,42,61,.25)" stroke-width="1.2"/>';
    }
    g.innerHTML = html;
  }
  var cores = [].slice.call(document.querySelectorAll('.cores button'));
  cores.forEach(function (b) {
    b.addEventListener('click', function () {
      cores.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
      desenhaRaia(b.getAttribute('data-cor'));
    });
  });
  desenhaRaia('#1F5FAD');

  // plataformas: corte da piscina (profundidade × altura da plataforma -> água que sobra), mesma conta da LP
  var corte = document.getElementById('plat-corte'), prof = document.getElementById('plat-prof'), alt = document.getElementById('plat-alt');
  function desenhaCorte() {
    if (!corte) return;
    var D = +prof.value, H = +alt.value, k = 0.8, sup = 34, fundo = sup + D * k, topo = fundo - H * k, sobra = D - H;
    var L = 'stroke="rgba(255,255,255,.85)" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"';
    var t = function (x, y, txt, cor, anc) { return '<text x="' + x + '" y="' + y + '" text-anchor="' + (anc || 'middle') + '" font-family="Instrument Sans, Arial" font-weight="700" font-size="13" fill="' + cor + '">' + txt + '</text>'; };
    var h = '<rect x="40" y="' + sup + '" width="290" height="' + (D * k) + '" fill="rgba(94,211,224,.22)"/>';
    h += '<path d="M40 ' + sup + 'H330" stroke="#5ED3E0" stroke-width="2"/>';
    h += '<path d="M8 26H40V' + fundo + 'H330V26H352" ' + L + '/>';
    // plataforma: tubos + painel
    var x0 = 170, x1 = 300;
    h += '<path d="M' + x0 + ' ' + fundo + 'V' + topo + 'M' + (x0 + 65) + ' ' + fundo + 'V' + topo + 'M' + x1 + ' ' + fundo + 'V' + topo + 'M' + x0 + ' ' + ((fundo + topo) / 2) + 'H' + x1 + '" stroke="#F5B41E" stroke-width="3" fill="none"/>';
    h += '<rect x="' + (x0 - 4) + '" y="' + (topo - 5) + '" width="' + (x1 - x0 + 8) + '" height="6" rx="2" fill="#F5B41E"/>';
    // cotas
    h += '<path d="M70 ' + sup + 'V' + fundo + 'M64 ' + sup + 'H76M64 ' + fundo + 'H76" stroke="#fff" stroke-width="1.4"/>';
    h += t(82, (sup + fundo) / 2 + 4, D + ' cm', '#fff', 'start');
    if (sobra > 0) {
      h += '<path d="M' + (x0 + 32) + ' ' + sup + 'V' + (topo - 6) + 'M' + (x0 + 26) + ' ' + sup + 'H' + (x0 + 38) + 'M' + (x0 + 26) + ' ' + (topo - 6) + 'H' + (x0 + 38) + '" stroke="#F5B41E" stroke-width="1.6"/>';
      h += t(x0 + 44, Math.max(sup + 14, (sup + topo) / 2 + 4), sobra + ' cm', '#F5B41E', 'start');
    }
    corte.innerHTML = h;
    document.getElementById('plat-d').textContent = D + ' cm';
    document.getElementById('plat-h').textContent = H + ' cm';
    document.getElementById('plat-res').innerHTML = sobra > 0 ? 'Sobram <b>' + sobra + ' cm</b> de água sobre a plataforma.' : 'Com essa altura, a plataforma <b>sai da água</b>: escolha uma mais baixa.';
  }
  if (corte) { prof.addEventListener('input', desenhaCorte); alt.addEventListener('input', desenhaCorte); desenhaCorte(); }
})();

/* loja: o kit vai inteiro para o carrinho (/cart/add.js) e o carrinho abre; sem JS ou com erro, segue para /cart */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kit]'); if (!b) return;
    var ids = b.getAttribute('data-kit').split(',').filter(Boolean);
    b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); location.href = '/cart'; })
      .catch(function () { b.disabled = false; location.href = '/cart'; });
  });
})();
